import { z } from 'zod'
import { detectionProfileSchema, type DetectionProfile } from '@/features/detection/domain/profile'
import { allRulesOn, ruleIds, type EngineRules } from '@/features/detection/domain/rules'

// Profil de calibration modifié sur la tablette (TEMPORAIRE, lot O7, jamais en production). Il remplace localement le
// profil figé de la mission pour le moteur de la tablette seulement : jamais envoyé au serveur, jamais en AUTO (le
// moteur ne fait qu'observer, le maintien de 3 s reste la seule confirmation).

export interface ProfileOverride {
  profile: DetectionProfile
  rules: EngineRules
}

const storageKey = 'reca-operator-v3.detection-override'

const rulesSchema = z.object(Object.fromEntries(ruleIds.map((id) => [id, z.boolean()])))

/** Le mode AUTO n'est jamais accepté ici : ramené à OBSERVATION. */
export function sanitizeOverride(profile: DetectionProfile, rules: EngineRules): ProfileOverride {
  return { profile: { ...profile, mode: profile.mode === 'AUTO' ? 'OBSERVATION' : profile.mode }, rules: { ...rules } }
}

export function readProfileOverride(): ProfileOverride | null {
  try {
    const raw = window.localStorage.getItem(storageKey)
    if (!raw) return null
    const value = JSON.parse(raw) as { profile?: unknown; rules?: unknown }
    const profile = detectionProfileSchema.safeParse(value.profile)
    if (!profile.success) return null
    const rules = rulesSchema.safeParse(value.rules ?? {})
    return sanitizeOverride(profile.data, rules.success ? { ...allRulesOn, ...rules.data } : allRulesOn)
  } catch {
    return null
  }
}

export function writeProfileOverride(override: ProfileOverride | null): void {
  try {
    if (override) window.localStorage.setItem(storageKey, JSON.stringify(override))
    else window.localStorage.removeItem(storageKey)
  } catch {
    // calibration non mémorisée : elle vaut pour la page ouverte
  }
}
